import numeral from 'numeral'
import firebase from 'firebase'
import dayjs from 'dayjs'
import Qs from 'query-string'

import i18next from 'i18n'
import Cookies from 'js-cookie'

export const PAGE_SIZE = 10;
const XOR_KEY = "cellwine-storage"

export const formatNumber = (value) => {
	return numeral(value).format('0,0')
}

export const formatDate = (value) => {
	return dayjs(value).format('YYYY/MM/DD')
}

export const deleteEmptyValue = (obj) => {
	let newObj = {}
	for (let key in obj) {
		const value = obj[key]
		if (!!value && value !== [] && value !== {}) {
			newObj[key] = value
		}
	}
	return newObj
}

export const receiptTypeEnum = {
	TWO_LINE: '2',
	THREE_LINE: '3',
	'2': i18next.t('two_line_receipt'),
	'3': i18next.t('three_line_receipt')
}

export const shippingTypeEnum = {
	HOME: 'home-delivery', // 貨運
	STORE_PICK_UP: 'store-pick-up', // 自取
	'home-delivery': i18next.t('home_delivery'),
	'store-pick-up': i18next.t('store_pick_up'),
}

export const shippingUrgencyEnum = {
	ORDINARY: '0', // normal 一般件
	NEXT_DAY: '1', // next day 隔日急件
	TODAY: '2', // today 當日特急件
	'0': i18next.t('ordinary'),
	'1': i18next.t('next_day_urgent'),
	'2': i18next.t('today_urgent'),
}

export const shippingTimeSessionEnum = {
	NOT_SPECIFY: '00:00:00', // 不指定
	MORNING: '13:00:00', // 13時前
	AFTERNOON: '18:00:00', // 14-18時
	NIGHT: '21:00:00', // 8時-21時
	'00:00:00': i18next.t('arrival_time_not_specify'),
	'13:00:00': i18next.t('arrival_time_morning'),
	'18:00:00': i18next.t('arrival_time_afternoon'),
	'21:00:00': i18next.t('arrival_time_night'),
}

export const couponTypeEnum = {
	SHIPPINGFEE: 'SHIPPINGFEE', // 物流費用
	SERVICEFEE: 'SERVICEFEE', // 服務費用
}

export const isObjectEmpty = (obj) => {
	for (let key in obj) {
		if (obj.hasOwnProperty(key))
			return false;
	}
	return true;
}

export const firebaseLogout = async () => {
	await firebase.auth().signOut()
}

export const facebookLoginAPI = async () => {
	const provider = new firebase.auth.FacebookAuthProvider()
	provider.addScope('email')
	Cookies.set('redirecting', true)
	await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
	await firebase.auth().signInWithRedirect(provider)
}

export const googleLoginAPI = async () => {
	const provider = new firebase.auth.GoogleAuthProvider()
	provider.addScope('email')
	Cookies.set('redirecting', true)
	await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
	console.log('sign In With Redirect')
	await firebase.auth().signInWithRedirect(provider)
		.then(result => console.log('google login succ'))
		.catch(error => console.log('google login error:', error))
}

export const signInWithEmailAndPasswordAPI = async data => {
	await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
	await firebase.auth().signInWithEmailAndPassword(data.email, data.password)
}

export const createUserWithEmailAndPasswordAPI = async data => {
	await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
	await firebase.auth().createUserWithEmailAndPassword(data.email, data.password)
}

export const sendResetPasswordEmail = async (email) => {
	await firebase.auth().sendPasswordResetEmail(email)
}

export const decryptHash = (hash) => {
	let decryptedBase64 = atob(hash)
	let decryptedBin = []
	for (let i = 0; i < decryptedBase64.length; ++i) {
		let xorBin = decryptedBase64.charCodeAt(i)
		let srcBin = xorBin
		for (let j = 0; j < XOR_KEY.length; ++j) {
			srcBin = srcBin ^ XOR_KEY.charCodeAt(j)
		}
		decryptedBin.push(srcBin)
	}
	let base64 = String.fromCharCode(...decryptedBin)
	// console.log(`base64: ${base64}`)
	let src = atob(base64)
	// console.log(`decrypted: ${src}`)
	return src
}

/*
Example:
Input: memberId=abc&status=unpaid&test=123123
Excepted output: JRARMx4qET4UEBZ+HhANLQ0pCXceHxV2JD12diUpBS8mEBYqIwARPSMDdz8KLQo/Ci0Keg==
PsudoCode:

get encoded base64 string of Input

foreach character in encoded base64 string:
	set srcAscii = get ascii code of the character
	set xored = srcAscii
	foreach character in XOR_KEY("cellwine-storage"):
		set xorAscii = get ascii code of the character
		set xored = xored XOR xorAscii
		set xordChar = convert the xored value as ascii code to character
set xordString = concat all xordChar
do another base 64 encode for xordString as final result
*/
export const encryptHash = (data) => {
	let i
	let base64 = btoa(data)
	// console.log(`base64 = ${base64}`)

	let encryptedBin = []
	for (i = 0; i < base64.length; ++i) {
		let srcBin = base64.charCodeAt(i)
		let xorSrc = srcBin
		for (let j = 0; j < XOR_KEY.length; ++j) {
			xorSrc = xorSrc ^ XOR_KEY.charCodeAt(j)
		}
		encryptedBin.push(xorSrc)
	}
	let result = btoa(String.fromCharCode(...encryptedBin))
	console.log(`encrypted: ${result}`)
	return result
}

export const parseLoactionSearch = () => {
	return Qs.parse(window.location.search);
}

export const convertNegativeToZero = (value) => {
	return value > 0 ? value : 0
}

export const calcDiscountPrice = (price, deduction = 0) => {
	let afterDiscount = numeral(price)
	if (!!deduction) {
		afterDiscount = afterDiscount.subtract(deduction)
	}
	return convertNegativeToZero(afterDiscount.value())
}
